module.exports = __webpack_public_path__ + "img/person.c6027821.png";